import Image from "next/image";
import Link from "next/link";
import LanguageSwitcher from "@/app/components/LanguageSwitcher";

export default function LoginHeader() {
  return (
    <header className="w-full bg-white shadow-custom h-[68px] relative flex items-center justify-between">
      <div className="px-4 py-1 flex items-center justify-start">
        <Link href="/">
          <Image
            // src="/universal/skillFull-logo.svg"
            src="/universal/talks-logo.svg"
            alt="skillFull logo"
            width={120}
            height={40}
            priority
          />
        </Link>
      </div>
      <div className="absolute top-1/2 -translate-y-1/2 right-5 z-[10]">
        <LanguageSwitcher />
      </div>
    </header>
  );
}
